import { CosmolexAccountingItem } from 'src/app/private/sale/accounting/tables/cosmolex-accounting-items-table/cosmolex-accounting-items-table.component';
import { centsToDollars, formatCentsToDollars } from '../money';
import { jsPDFWithPlugin } from 'src/app/private/home/components/all-files-list/all-files-list.component';
import jsPDF from 'jspdf';
import { format } from 'date-fns';
import { formatPercent } from '../number';
import { removeIllegalCharactersFromFileName } from '../documents';
import { AccountingItem } from 'src/app/private/sale/accounting/accounting.models';

export const getCosmolexTxtBlob = (
	data: CosmolexAccountingItem[],
	accountingNumber: string,
): Blob => {
	const csvData = data.map((item) => [
		`"${accountingNumber.trim()}"`,
		'""',
		'""',
		`"${item.title.trim()}"`,
		`"${centsToDollars(item.amount)}"`,
		`"${item.hst ? 'Y' : 'N'}"`,
	]);

	const csv = csvData.map((row) => row.join(' '));

	const csvArray = csv.join('\r\n');

	const blob = new Blob([csvArray], { type: 'text/plain' });

	return blob;
};

export const cosmolexExport = (
	data: AccountingItem[],
	accountingNumber: string,
	fileNumber: string,
	fileName: string,
) => {
	const blob = getCosmolexTxtBlob(
		data as CosmolexAccountingItem[],
		accountingNumber,
	);

	const a = document.createElement('a');
	const url = window.URL.createObjectURL(blob);

	fileNumber = removeIllegalCharactersFromFileName(fileNumber);
	fileName = removeIllegalCharactersFromFileName(fileName);

	a.href = url;
	a.download = `${fileNumber}_${fileName}_${format(new Date(), 'MM-dd-yyyy')}.txt`;
	a.click();
	window.URL.revokeObjectURL(url);
	a.remove();
};

export const cosmolexPrint = (
	hstItems: AccountingItem[],
	hstItemsHst: number,
	hstItemsTotal: number,
	nonHstItems: AccountingItem[],
	nonHstItemsTotal: number,
	hst: number,
	accountingNumber: string,
	fileNumber: string,
	fileName: string,
) => {
	const doc = new jsPDF({
		orientation: 'portrait',
		unit: 'mm',
	}) as jsPDFWithPlugin;

	doc.setFontSize(10);
	doc.setFont(undefined, 'bold');
	doc.text(`Date: ${new Date().toLocaleDateString('en-US')}`, 14, 10);
	doc.text(`File Number: ${fileNumber}`, 14, 14);
	doc.text(`File Name: ${fileName}`, 14, 18);
	doc.text(`Accounting Number: ${accountingNumber}`, 14, 22);

	const columnStyles = {
		0: { cellWidth: 110 },
		1: { cellWidth: 70, halign: 'right' },
	};

	const headStyles = {
		fillColor: '044321',
	};

	const hstDisbursementesBodyItems = [
		...hstItems.map((item) => [
			item.title,
			`${formatCentsToDollars(item.amount)}`,
		]),
		[
			'\n Total',
			`HST (${formatPercent(hst)}%) ${formatCentsToDollars(hstItemsHst)}\n${formatCentsToDollars(hstItemsTotal)}`,
		],
	];

	doc.autoTable({
		startY: 26,
		head: [[`HST Disbursements (${hstItems.length})`, 'Amount']] as any,
		body: hstDisbursementesBodyItems,
		columnStyles: columnStyles as any,
		headStyles: headStyles as any,
		didParseCell: (data) => {
			if (data.cell && data.cell.section === 'head') {
				switch (data.cell.raw) {
					case 'Amount':
						data.cell.styles.halign = 'right';
				}
			}

			if (data.row.index === hstDisbursementesBodyItems.length - 1) {
				data.cell.styles.fontStyle = 'bold';
			}
		},
	});

	const finalY = (doc as any).lastAutoTable.finalY;

	const nonHstDisbursementesBodyItems = [
		...nonHstItems.map((item) => [
			item.title,
			`${formatCentsToDollars(item.amount)}`,
		]),
		['Total', `${formatCentsToDollars(nonHstItemsTotal)}`],
	];

	doc.autoTable({
		startY: finalY + 10,
		head: [[`Non HST Disbursements (${nonHstItems.length})`, 'Amount']] as any,
		body: nonHstDisbursementesBodyItems,
		columnStyles: columnStyles as any,
		headStyles: headStyles as any,
		didParseCell: (data) => {
			if (data.cell && data.cell.section === 'head') {
				switch (data.cell.raw) {
					case 'Amount':
						data.cell.styles.halign = 'right';
				}
			}

			if (data.row.index === nonHstDisbursementesBodyItems.length - 1) {
				data.cell.styles.fontStyle = 'bold';
			}
		},
	});
	doc.autoPrint();

	const url = doc.output('bloburl').toString();

	return url;
};
